import type { IModeInfoBanner } from '../../interfaces/Withdrawal';

/**
 * The banner title carries a `%s%` placeholder that `placeholderText` fills,
 * quoted — mirroring `SavedWithdrawalModesFragment.setUpBankDetails`.
 */
export function formatBannerTitle(banner?: IModeInfoBanner): string {
  const title = banner?.title?.text;
  if (!title) return '';

  const placeholder = banner?.title?.placeholderText;
  if (!placeholder) return title;

  return title.replace('%s%', `"${placeholder}"`);
}

/**
 * Android: `isEnabled = !isKycApproved || allowChange`.
 *
 * An unapproved KYC leaves the control active so the user can act on it, and
 * an approved one only opens when the server explicitly permits a change.
 */
export function canChangeMode(
  isKycApproved?: boolean,
  allowChange?: boolean,
): boolean {
  return !isKycApproved || Boolean(allowChange);
}
